import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '../../../services/translation.service';

@Component({
    selector: 'app-delete-account-modal',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './delete-account-modal.component.html',
    styleUrl: './delete-account-modal.component.scss',
})
export class DeleteAccountModalComponent {
    constructor(
        private activeModale: NgbActiveModal,
        private authService: AuthService,
        private toaster: ToastrService,
        private translationService: TranslationService
    ) {}

    cancel() {
        this.activeModale.close('cancel');
    }

    async validate() {
        this.activeModale.close('validate');
        try {
            let response = await firstValueFrom(this.authService.deleteMe());

            this.authService.logout();

            setTimeout(() => {
                const successMessage = this.translationService.instant(
                    'common.messages.operationSuccess'
                );
                this.toaster.success(successMessage);
            }, 2000);
        } catch {
            const errorMessage = this.translationService.instant(
                'errors.network.serverError'
            );
            this.toaster.error(errorMessage);
        }
    }
}
